import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, PopOver } from '@utahdts/dts-react-common';
import Icon from './Icon';

const propTypes = {
  children: PropTypes.node.isRequired,
};

/**
 * Shared row-actions ("tool"/ellipsis) popover for table action cells.
 * Visibility is controlled here so that clicking any action inside the popup
 * also collapses it (the uncontrolled PopOver only closes on outside clicks).
 */
const RowActionsPopover = ({ children }) => {
  const [showPopup, setShowPopup] = useState(false);

  return (
    <PopOver
      anchor={
        <Button
          label=""
          children={Icon.iconEllipsis()}
          className="button--naked ellipsis"
          onClick={() => false}
        />
      }
      dismissible={true}
      mode={PopOver.MODE?.CLICK || 'click'}
      position={PopOver.POSITION?.BOTTOM || 'bottom'}
      showPopup={showPopup}
      onPopoverToggle={setShowPopup}
    >
      <div onClick={() => setShowPopup(false)}>{children}</div>
    </PopOver>
  );
};

RowActionsPopover.propTypes = propTypes;

export default RowActionsPopover;
